var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconResults(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 290.63 261.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e2c4ff;}.cls-2{fill:#020288;}.cls-3{fill:none;stroke:#020288;stroke-miterlimit:10;stroke-width:10px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5,
    y: 5,
    width: 280.63,
    height: 251.72,
    rx: 10.96,
    ry: 10.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 5.19,
    y: 177.91,
    width: 279.69,
    height: 31.75
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 178.1,
    y: 214.39,
    width: 85.42,
    height: 23.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 175.65,
    y: 146.73,
    width: 91.46,
    height: 12.85,
    rx: 6.43,
    ry: 6.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 175.65,
    y: 123.68,
    width: 91.46,
    height: 12.85,
    rx: 6.43,
    ry: 6.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 175.65,
    y: 100.62,
    width: 91.46,
    height: 12.85,
    rx: 6.43,
    ry: 6.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 175.65,
    y: 77.57,
    width: 91.46,
    height: 12.85,
    rx: 6.43,
    ry: 6.43
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.73,
    y: 27.68,
    width: 128.13,
    height: 126.61
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 260.69,
    cy: 31.83,
    r: 6.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m83.77,112.64c-.53,4.12-.41,7.99-1.62,11.4-1.36,3.85-3.59,7.5-6.01,10.82-2.11,2.88-5.62,2.88-8.07.76-2.41-2.08-2.73-5.54-.36-8.14,3.73-4.07,4.5-8.85,4.21-14.06-.09-1.67-.77-2.32-2.43-2.41-5.21-.3-9.99.47-14.05,4.22-2.59,2.39-6.09,2.05-8.13-.36-2.14-2.53-1.9-5.61.7-8.16,4.88-4.79,10.9-6.78,17.59-7.09,1.42-.07,2.84,0,4.64,0-.16-8.48,1.22-16.36,7.45-22.64,6.25-6.3,14-8.07,22.66-7.65.26-3.06.4-5.97.78-8.85.66-5.06,2.83-9.45,6.31-13.18,2.72-2.92,6.05-3.25,8.58-.94,2.39,2.18,2.52,5.6,0,8.39-3.72,4.1-4.35,8.97-3.82,14.13.07.71,1.15,1.8,1.86,1.87,5.16.54,10.03-.09,14.14-3.8,2.81-2.53,6.21-2.42,8.39-.03,2.32,2.54,1.98,5.87-.9,8.58-4.9,4.6-10.85,6.51-17.43,6.79-1.41.06-2.82,0-4.55,0,.26,8.64-1.26,16.48-7.51,22.74-6.26,6.27-14.06,7.89-22.4,7.61Zm18.07-20.82c.11-3.39.29-6.37.23-9.35-.01-.57-.96-1.58-1.49-1.59-3.04-.06-6.09.12-9.46.24,3.73,3.73,6.93,6.91,10.73,10.71Zm-9.37,9c-3.57-3.65-6.74-6.9-10.37-10.61-.09,3.28-.26,6.33-.18,9.37.01.52,1.04,1.44,1.62,1.45,2.96.06,5.93-.12,8.94-.22Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResults);
export default __webpack_public_path__ + "static/media/icon-results.980ae6379a8ecd22fc851f36283b8b50.svg";
export { ForwardRef as ReactComponent };